import { render, staticRenderFns } from "./by-item-grid.vue?vue&type=template&id=ec4de020&scoped=true&"
import script from "./by-item-grid.vue?vue&type=script&lang=js&"
export * from "./by-item-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4de020",
  null
  
)

export default component.exports